import React, { useContext, useState } from 'react'
import henceforthApi from '../utils/henceforthApi';
import { NumberValidation } from '../utils/validations';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom'
import moment from 'moment';
import { toast } from 'react-toastify';
import { GlobalContext } from '../context/Provider';
import henceofrthEnums from '../utils/henceofrthEnums';

interface addcoupon {
  code: string,
  type: string
  amount: number,
  usesTimes: string,
  expire: string,
  currency: string
}

function CouponsAdd() {
  const [loading, setLoading] = useState(false);
  const PERCENTAGE_COUPONS = 'PERCENTAGE'
  const FIXED_COUPONS = 'FIXED'
  const [coupons, setCoupons] = useState({
    code: "",
    type: "",
    amount: 0,
    usesTimes: "",
    expire: "",
    currency: "CAD"
  } as addcoupon)
  let navigate = useNavigate()
  const handleChange = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    setCoupons({
      ...coupons,
      [name]: value
    })
    NumberValidation(String(coupons.amount))
  }

  console.log("coupon", coupons)

  const handleSubmit = async () => {
    // setDisabledLoading(true)
    const code = coupons.code.trim()
    const day = coupons.usesTimes.trim()
    if (!code || !day) {
      return toast.warn('Spaces are not allowed as character')
    }
    if (!NumberValidation(day)) {
      return toast.warn('Time uses in Number')
    }
    if (Number(coupons.amount) == 0) {
      return toast.warn('Coupons amount cannot be 0')
    }
    const items = {
      name: code,
      expire_date: coupons.expire,
      use_time: Number(day),
      coupon_type: coupons.type,
    } as any

    console.log("items", items)
    if (coupons.type === FIXED_COUPONS) {
      items['price'] = Number(coupons.amount)
      items['currency'] = coupons.currency ?? 'CAD'
    } else {
      items['max_discount'] = Number(coupons.amount)
    }
    try {
      setLoading(true)
      if (coupons.amount <= 5) {
        await henceforthApi.Coupons.getCoupons(items).then((res: any) => {
          Swal.fire({
            title: "Coupon Added",
            text: "Coupon Added successfully",
            icon: "success",
            confirmButtonText: "OK",
          })
          navigate("/coupons/1")
          // CouponList()
        }).catch((err: any) => {
          console.log("delte failed", err);
          Swal.fire({
            title: "Coupon Added Failed",
            text: err.response.body.error_description || err.error_description.message,
            icon: "error",
            confirmButtonText: "Cancel",
          });
        });
        setCoupons({
          code: "",
          type: "",
          amount: "",
          usesTimes: "",
          expire: "",

        } as any)
      }
      else {
        toast.error(`Maximum discount allowed is ${coupons.type == "FIXED" ? (coupons.currency == henceofrthEnums.CurrencyType.NGN ? '₦ 5' : coupons.currency == henceofrthEnums.CurrencyType.INR ? '₹ 50' : '$ 5') : `5 %`} `)
      }
      setLoading(false)
    }
    catch {
      // toast.error("please enter less than 5 discount")
      console.log("error")
      setLoading(false)
    }
  }
  return (
    <>
      {/* Page Header */}
      <div className="row font mb-3 align-items-center">
        <div className="col-auto me-auto">
          <h2 className="mb-0">Create Coupon</h2>
        </div>
        <div className="col-auto">
          <button
            type="button"
            className="btn btn-color"
            onClick={() => { window.history.back() }}
          >
            Back
          </button>
        </div>
      </div>

      {/* Form Card */}
      <div className="ibox animated fadeInRight">
        <div className="ibox-content p-4">
          <form onSubmit={(e: any) => { e.preventDefault(); handleSubmit() }}>
            <div className="row g-3">
              {/* Coupon Code */}
              <div className="col-md-6">
                <label className="form-label font-weight-bold mb-1">
                  <b>Coupon Code</b> <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={coupons.code}
                  onChange={handleChange}
                  name="code"
                  placeholder="Enter coupon code"
                  required
                />
              </div>

              {/* Type */}
              <div className="col-md-6">
                <label className="form-label font-weight-bold mb-1">
                  <b>Type</b> <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  value={coupons.type}
                  onChange={handleChange}
                  name="type"
                  required
                >
                  <option value="" disabled>Choose Type</option>
                  <option value={FIXED_COUPONS}>FIXED</option>
                  <option value={PERCENTAGE_COUPONS}>PERCENTAGE</option>
                </select>
              </div>

              {/* Coupon Amount */}
              <div className="col-md-6">
                <label className="form-label font-weight-bold mb-1">
                  <b>Coupon Amount</b> <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  {coupons.type === FIXED_COUPONS ? (
                    <select
                      className="form-select"
                      style={{ maxWidth: '120px' }}
                      aria-label="Select currency"
                      value={coupons.currency}
                      onChange={handleChange}
                      name="currency"
                    >
                      <option value="CAD">$ CAD</option>
                      <option value="USD">$ USD</option>
                      <option value="NGN">₦ NGN</option>
                      <option value="INR">₹ INR</option>
                    </select>
                  ) : (
                    <span className="input-group-text">{coupons.type === PERCENTAGE_COUPONS ? "%" : "$"}</span>
                  )}
                  <input
                    type="text"
                    className="form-control"
                    value={coupons.amount}
                    maxLength={3}
                    id="input1"
                    onChange={handleChange}
                    name="amount"
                    placeholder={coupons.type === FIXED_COUPONS ? "Enter coupon amount" : "Enter coupon percentage"}
                    required
                  />
                </div>
              </div>

              {/* No. of Times Uses */}
              <div className="col-md-6">
                <label className="form-label font-weight-bold mb-1">
                  <b>No. of Times Uses</b> <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={coupons.usesTimes}
                  onChange={handleChange}
                  name="usesTimes"
                  placeholder="Enter uses count"
                  required
                />
              </div>

              {/* Expire Date */}
              <div className="col-md-6">
                <label className="form-label font-weight-bold mb-1">
                  <b>Expire Date</b> <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  min={moment().format("YYYY-MM-DD")}
                  value={coupons.expire}
                  onChange={handleChange}
                  name="expire"
                  placeholder="Enter expire date"
                  required
                />
              </div>
            </div>

            <div className="mt-4">
              <button
                type="submit"
                disabled={loading}
                className="btn btn-color px-4"
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default CouponsAdd;
